import {useRouter} from "next/router";
import {useUser} from "../react-query/useUser";
import {useState} from "react";
import useAsyncEffect from "use-async-effect";

export const useRedirectAnonymous = () => {
    const router = useRouter();
    const {user, userIsLoading} = useUser();
    const [authenticated, setAuthenticated] = useState<boolean>(false);

    useAsyncEffect(async () => {
        if (!userIsLoading && !user) {
            setAuthenticated(false);
           await router.push('/');
        } else {
            setAuthenticated(true);
        }

    }, [user])

    return authenticated;

}
